import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0971427e")

_pushScopeId("data-v-0971427e")
const _hoisted_1 = { class: "info-padding" }
const _hoisted_2 = { class: "delete-model info-title-bottom" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "line" }, null, -1)
const _hoisted_5 = { class: "display-flex info-title-havbutton-bottom" }
const _hoisted_6 = { class: "title" }
const _hoisted_7 = { class: "flex1 display-flex justify-content-end" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_button_tip = _resolveComponent("button-tip")
  const _component_add_button = _resolveComponent("add-button")
  const _component_device_icon = _resolveComponent("device-icon")
  const _component_device_status = _resolveComponent("device-status")
  const _component_list = _resolveComponent("list")
  const _component_device_set_dialog = _resolveComponent("device-set-dialog")
  const _component_people_set_dialog = _resolveComponent("people-set-dialog")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.peopleInfo, (item, index) => {
        return (_openBlock(), _createBlock("div", { key: index }, [
          (_ctx.enableLandLine==1 || item.name != 'Phone')
            ? (_openBlock(), _createBlock("div", {
                key: 0,
                class: [index!=_ctx.peopleInfo.length-1?'info-title-bottom':'', 'position-rel']
              }, [
                _createVNode("label", _hoisted_3, _toDisplayString(item.title), 1),
                _createVNode("label", null, _toDisplayString(item.content), 1),
                (item.name === 'Name')
                  ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                      (Number(item.role) === _ctx.account.personnelRole)
                        ? (_openBlock(), _createBlock(_component_button_tip, {
                            key: 0,
                            class: "margin-left10px"
                          }, {
                            default: _withId(() => [
                              _createTextVNode(_toDisplayString(_ctx.$wordList.ProperAllTextPersonnel), 1)
                            ]),
                            _: 1
                          }))
                        : (_openBlock(), _createBlock(_component_button_tip, {
                            key: 1,
                            class: "margin-left10px"
                          }, {
                            default: _withId(() => [
                              _createTextVNode(_toDisplayString(_ctx.$wordList.OfficeStaff), 1)
                            ]),
                            _: 1
                          })),
                      _createVNode("span", {
                        class: "el-icon-edit right",
                        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.editPeople && _ctx.editPeople(...args)))
                      })
                    ], 64))
                  : _createCommentVNode("", true)
              ], 2))
            : _createCommentVNode("", true)
        ]))
      }), 128)),
      _hoisted_4,
      _createVNode("div", _hoisted_5, [
        _createVNode("label", _hoisted_6, _toDisplayString(_ctx.devices.length) + " " + _toDisplayString(_ctx.$wordList.ProperAllTextDevice), 1),
        _createVNode("div", _hoisted_7, [
          _createVNode(_component_add_button, {
            onClick: _ctx.addDevice,
            class: "info-title-button"
          }, null, 8, ["onClick"])
        ])
      ]),
      _createVNode(_component_list, {
        "show-check": false,
        headers: _ctx.deviceHeader,
        "list-data": _ctx.devices,
        showDefaultAction: [],
        update: _ctx.updateList,
        action: _ctx.deviceAction,
        onInfo: _ctx.goToDeviceInfo,
        onEdit: _ctx.editDevice,
        "delete-url": "v3/web/office/device/delete"
      }, {
        LocationSlotHeader: _withId((data) => [
          _createVNode("div", {
            class: "sort-header",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.getSortRes('peopleInfoDevice', 'Location')))
          }, [
            _createTextVNode(_toDisplayString(data.scope.label) + " ", 1),
            _createVNode("img", {
              src: _ctx.getSortImg('peopleInfoDevice', 'Location')
            }, null, 8, ["src"])
          ])
        ]),
        CreateTimeSlotHeader: _withId((data) => [
          _createVNode("div", {
            class: "sort-header",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.getSortRes('peopleInfoDevice', 'CreateTime')))
          }, [
            _createTextVNode(_toDisplayString(data.scope.label) + " ", 1),
            _createVNode("img", {
              src: _ctx.getSortImg('peopleInfoDevice', 'CreateTime')
            }, null, 8, ["src"])
          ])
        ]),
        TypeSlot: _withId((data) => [
          _createVNode(_component_device_icon, {
            class: "vertical-align-middle",
            type: Number(data.scope.Type)
          }, null, 8, ["type"])
        ]),
        StatusSlot: _withId((data) => [
          _createVNode(_component_device_status, {
            class: "vertical-align-middle",
            type: Number(data.scope.Status)
          }, null, 8, ["type"])
        ]),
        _: 1
      }, 8, ["headers", "list-data", "update", "action", "onInfo", "onEdit"]),
      (_ctx.isShowDeviceDialog)
        ? (_openBlock(), _createBlock(_component_device_set_dialog, {
            key: 0,
            "opera-type": _ctx.operaType,
            "init-form": _ctx.initDeviceData,
            identity: "office",
            onClose: _cache[4] || (_cache[4] = ($event: any) => (_ctx.isShowDeviceDialog = false)),
            onSuccess: _ctx.getOwnerDevice
          }, null, 8, ["opera-type", "init-form", "onSuccess"]))
        : _createCommentVNode("", true),
      (_ctx.isShowPeopleDialog)
        ? (_openBlock(), _createBlock(_component_people_set_dialog, {
            key: 1,
            initForm: _ctx.userDetailFormData,
            operate: "edit",
            onClose: _cache[5] || (_cache[5] = ($event: any) => (_ctx.isShowPeopleDialog = false)),
            onUpdate: _ctx.getUserInfo
          }, null, 8, ["initForm", "onUpdate"]))
        : _createCommentVNode("", true)
    ])
  ]))
})